<table-toolbar-wrapper [hide]="!toolbarConfigs">
    <acl-ngx-table-toolbar [selectedCount]="selectedRows.length">
        <acl-ngx-table-toolbar-options
            [hide]="selectedRows.length > 0 || !toolbarConfigs || !toolbarConfigs.toolbarOptions"
            [moreOptions]="toolbarConfigs?.toolbarOptions?.moreOptions"
            [isAddButtonVisible]="toolbarConfigs?.toolbarOptions?.isAddButtonVisible || false"
            [isAddButtonDisabled]="toolbarConfigs?.toolbarOptions?.isAddButtonDisabled"
            [isExportButtonVisible]="toolbarConfigs?.toolbarOptions?.isExportButtonVisible || false"
            [isExportButtonDisabled]="toolbarConfigs?.toolbarOptions?.isExportButtonDisabled"
            [isMoreOptionsVisible]="toolbarConfigs?.toolbarOptions?.isMoreOptionsVisible || false"
            [isMoreOptionsDisabled]="toolbarConfigs?.toolbarOptions?.isMoreOptionsDisabled"
            [isRefreshVisible]="toolbarConfigs?.toolbarOptions?.isRefreshVisible || false"
            (addClick)="toolbarConfigs?.toolbarOptions?.onAddClick()"
            (exportClick)="toolbarConfigs?.toolbarOptions?.onExportClick()" (refreshClick)="reloadTable()">
        </acl-ngx-table-toolbar-options>
        <toolbar-input [hide]="selectedRows.length > 0 || !toolbarConfigs || !toolbarConfigs.isSearchEnable"
            (onSearchTextChange)="handleOnSearchTextChange($event)"></toolbar-input>
        <list-filter [hide]="selectedRows.length > 0 || !toolbarConfigs || !toolbarConfigs.filterSetup"
            [filterSetup]="toolbarConfigs?.filterSetup" (filterSelected)="handleOnFilterSelected($event)">
        </list-filter>
        <acl-ngx-bulk-options [hide]="!selectedRows.length || !toolbarConfigs || !toolbarConfigs.bulkOptions"
            [selectedCount]="selectedRows.length" [moreOptions]="toolbarConfigs?.bulkOptions?.moreOptions"
            [isBulkEditDisabled]="toolbarConfigs?.bulkOptions?.isBulkEditDisabled"
            [isBulkEditVisible]="toolbarConfigs?.bulkOptions?.isBulkEditVisible || false"
            [isBulkCopyDisabled]="toolbarConfigs?.bulkOptions?.isBulkCopyDisabled"
            [isBulkCopyVisible]="toolbarConfigs?.bulkOptions?.isBulkCopyVisible || false"
            [isBulkStartDisabled]="toolbarConfigs?.bulkOptions?.isBulkStartDisabled"
            [isBulkStartVisible]="toolbarConfigs?.bulkOptions?.isBulkStartVisible || false"
            [isBulkPauseDisabled]="toolbarConfigs?.bulkOptions?.isBulkPauseDisabled"
            [isBulkPauseVisible]="toolbarConfigs?.bulkOptions?.isBulkPauseVisible || false"
            [isBulkRemoveDisabled]="toolbarConfigs?.bulkOptions?.isBulkRemoveDisabled"
            [isBulkRemoveVisible]="toolbarConfigs?.bulkOptions?.isBulkRemoveVisible || false"
            (bulkEditClick)="toolbarConfigs?.bulkOptions?.onBulkEditClick()"
            (bulkCopyClick)="toolbarConfigs?.bulkOptions?.onBulkCopyClick()"
            (bulkStartClick)="toolbarConfigs?.bulkOptions?.onBulkStartClick()"
            (bulkPauseClick)="toolbarConfigs?.bulkOptions?.onBulkPauseClick()"
            (bulkRemoveClick)="toolbarConfigs?.bulkOptions?.onBulkRemoveClick()">
        </acl-ngx-bulk-options>
    </acl-ngx-table-toolbar>
    <list-filter-selected [hide]="selectedRows.length > 0 || !toolbarConfigs || !toolbarConfigs.filterSetup"
        [filterSetup]="toolbarConfigs?.filterSetup" [filters]="preSelectedFilters"
        (filterChanged)="handleOnFilterChanged($event)">
    </list-filter-selected>
</table-toolbar-wrapper>
<acl-ngx-data-table *ngIf="!reloadTableTriggered" [data]="data" [columns]="columns"
    [disableSorting]="tableConfigs.disableSorting" [defaultSort]="tableConfigs.defaultSort"
    [uniqueIdAccessor]="tableConfigs.uniqueIdAccessor" [isSelectionEnabled]="tableConfigs.isSelectionEnabled"
    [pageCount]="pageCount" [pageSize]="tableConfigs.pageSize" [totalRows]="totalRows"
    [isPaginationEnabled]="tableConfigs.isPaginationEnabled" [showSummaryRow]="tableConfigs.showSummaryRow"
    [stickyHeader]="tableConfigs.stickyHeader" [stickyColumnHeaders]="tableConfigs.stickyColumnHeaders"
    [enableStickyColumns]="tableConfigs.enableStickyColumns" [showCallToAction]="tableConfigs.showCallToAction"
    [callToActionProps]="tableConfigs.callToActionProps" (rowSelectionChange)="handleOnRowSelectionChange($event)"
    (fetchData)="handleOnFetchData($event)">
</acl-ngx-data-table>

<amobee-loader [loading]="!isTableReady"></amobee-loader>